// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivitySkeletonController from "./activity_skeleton_controller"
application.register("activity-skeleton", ActivitySkeletonController)

import Application__FormController from "./application/form_controller"
application.register("application--form", Application__FormController)

import Application__InstructionsController from "./application/instructions_controller"
application.register("application--instructions", Application__InstructionsController)

import AsyncDownloadController from "./async_download_controller"
application.register("async-download", AsyncDownloadController)

import Autoscaler__FormController from "./autoscaler/form_controller"
application.register("autoscaler--form", Autoscaler__FormController)

import Autoscaler__QueuesChipsController from "./autoscaler/queues_chips_controller"
application.register("autoscaler--queues-chips", Autoscaler__QueuesChipsController)

import AutoscalerChartController from "./autoscaler_chart_controller"
application.register("autoscaler-chart", AutoscalerChartController)

import AutoscalerSparklineController from "./autoscaler_sparkline_controller"
application.register("autoscaler-sparkline", AutoscalerSparklineController)

import BlurToggleController from "./blur_toggle_controller"
application.register("blur-toggle", BlurToggleController)

import CapacityNotifier__FormController from "./capacity_notifier/form_controller"
application.register("capacity-notifier--form", CapacityNotifier__FormController)

import CapacityNotifierOverrideController from "./capacity_notifier_override_controller"
application.register("capacity-notifier-override", CapacityNotifierOverrideController)

import ChartReloadController from "./chart_reload_controller"
application.register("chart-reload", ChartReloadController)

import ChartStatesController from "./chart_states_controller"
application.register("chart-states", ChartStatesController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmClickController from "./confirm_click_controller"
application.register("confirm-click", ConfirmClickController)

import ContextPickerController from "./context_picker_controller"
application.register("context-picker", ContextPickerController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import EmbedSpinnerController from "./embed_spinner_controller"
application.register("embed-spinner", EmbedSpinnerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlashDispatcherController from "./flash_dispatcher_controller"
application.register("flash-dispatcher", FlashDispatcherController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import Form__AutofocusController from "./form/autofocus_controller"
application.register("form--autofocus", Form__AutofocusController)

import Form__BreakoutController from "./form/breakout_controller"
application.register("form--breakout", Form__BreakoutController)

import Form__ConfirmationController from "./form/confirmation_controller"
application.register("form--confirmation", Form__ConfirmationController)

import Form__IdController from "./form/id_controller"
application.register("form--id", Form__IdController)

import Form__ModalComponentCloserController from "./form/modal_component_closer_controller"
application.register("form--modal-component-closer", Form__ModalComponentCloserController)

import Form__OtpController from "./form/otp_controller"
application.register("form--otp", Form__OtpController)

import Form__RangeNumberController from "./form/range_number_controller"
application.register("form--range-number", Form__RangeNumberController)

import Form__RefreshOnSubmitController from "./form/refresh_on_submit_controller"
application.register("form--refresh-on-submit", Form__RefreshOnSubmitController)

import Form__ReloadOnChangeController from "./form/reload_on_change_controller"
application.register("form--reload-on-change", Form__ReloadOnChangeController)

import Form__SpinnerController from "./form/spinner_controller"
application.register("form--spinner", Form__SpinnerController)

import Form__TurnstileController from "./form/turnstile_controller"
application.register("form--turnstile", Form__TurnstileController)

import Form__UrlController from "./form/url_controller"
application.register("form--url", Form__UrlController)

import Form__VisitController from "./form/visit_controller"
application.register("form--visit", Form__VisitController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import Manager__FormController from "./manager/form_controller"
application.register("manager--form", Manager__FormController)

import Manager__NotificationsController from "./manager/notifications_controller"
application.register("manager--notifications", Manager__NotificationsController)

import ManagerSwitchComponentController from "./manager_switch_component_controller"
application.register("manager-switch-component", ManagerSwitchComponentController)

import ModalComponentController from "./modal_component_controller"
application.register("modal-component", ModalComponentController)

import OpenModalComponentController from "./open_modal_component_controller"
application.register("open-modal-component", OpenModalComponentController)

import PagyController from "./pagy_controller"
application.register("pagy", PagyController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)

import QrcodeController from "./qrcode_controller"
application.register("qrcode", QrcodeController)

import RangeOutputController from "./range_output_controller"
application.register("range-output", RangeOutputController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import RemoveController from "./remove_controller"
application.register("remove", RemoveController)

import ScalingAnimationController from "./scaling_animation_controller"
application.register("scaling-animation", ScalingAnimationController)

import ScalingEventEntranceController from "./scaling_event_entrance_controller"
application.register("scaling-event-entrance", ScalingEventEntranceController)

import Schedule__FormController from "./schedule/form_controller"
application.register("schedule--form", Schedule__FormController)

import ScrollFadeController from "./scroll_fade_controller"
application.register("scroll-fade", ScrollFadeController)

import ShowController from "./show_controller"
application.register("show", ShowController)

import SidebarRevealController from "./sidebar_reveal_controller"
application.register("sidebar-reveal", SidebarRevealController)

import SpinnerController from "./spinner_controller"
application.register("spinner", SpinnerController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import Subscription__FormController from "./subscription/form_controller"
application.register("subscription--form", Subscription__FormController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimeAgoInWordsController from "./time_ago_in_words_controller"
application.register("time-ago-in-words", TimeAgoInWordsController)

import TimeRange__FormController from "./time_range/form_controller"
application.register("time-range--form", TimeRange__FormController)

import TimeRange__SortableController from "./time_range/sortable_controller"
application.register("time-range--sortable", TimeRange__SortableController)

import TimeUntilInWordsController from "./time_until_in_words_controller"
application.register("time-until-in-words", TimeUntilInWordsController)

import ToggleSlideController from "./toggle_slide_controller"
application.register("toggle-slide", ToggleSlideController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboFrameReloaderController from "./turbo_frame_reloader_controller"
application.register("turbo-frame-reloader", TurboFrameReloaderController)

import User__FormController from "./user/form_controller"
application.register("user--form", User__FormController)
